import { Button } from "@/components/ui/button";
import { blogPosts } from "@/data/blog-posts";
import { ArrowRight, Clock, Tag } from "lucide-react";
import { Link } from "react-router-dom";

export const BlogSection = () => {
  // Pega os primeiros 3 posts para exibir na seção
  const featuredBlogPosts = blogPosts.slice(0, 3);

  return (
    <section className=" py-10 md:py-24 bg-white">
      <div className="container">
        <div className="flex items-center justify-between mb-12">
          <div>
            <span className="text-sm text-n-text  mb-2 block">Blog</span>
            <h2 className="text-n-text-green text-3xl font-semibold md:text-4xl lg:text-5xl max-w-5xl">
              Dicas e novidades sobre como transportar o seu veículo de maneira
              rápida e segura
            </h2>
          </div>
          <div className="hidden md:block">
            <Link to="/blog">
              <Button
                variant="outline"
                className="text-n-text-green hover:text-n-text hover:bg-n-green-h-light"
              >
                Ver todos
              </Button>
            </Link>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredBlogPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="group bg-white rounded-xl border border-n-beige overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 hover:bg-n-beige"
            >
              <div className="aspect-video bg-gray-200 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                />
              </div>

              <div className="p-6">
                <div className="flex items-center gap-4 mb-3">
                  <div className="flex items-center gap-1">
                    <Tag className="h-3 w-3 text-n-text-green" />
                    <span className="text-xs font-medium text-n-text-green bg-green-50 px-2 py-1 rounded">
                      {post.category}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-n-text-neutral">
                    <Clock className="h-3 w-3" />
                    <span className="text-xs">{post.readTime}</span>
                  </div>
                </div>

                <h3 className="font-semibold text-2xl  text-n-text mb-2 group-hover:text-n-text-green transition-colors line-clamp-2">
                  {post.title}
                </h3>

                <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>

                <div className="flex items-center gap-2 text-n-text-green font-medium text-sm group-hover:gap-3 transition-all">
                  Leia mais
                  <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:hidden">
          <Link to="/blog">
            <Button
              variant="outline"
              className="text-n-text-green border-n-text-green hover:bg-n-text-green hover:text-white"
            >
              Ver todos os artigos
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
